import { Typography } from '@compass/components'
import { cn } from '@compass/utils'

import { useGetEnvironmentName } from '../../../hooks/useGetEnvironmentName'
import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { FeatureGatedColumnMeta } from '.'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.Environment
const label = visitFilterLabelMap[key]
const MAX_WIDTH_COLUMN_THRESHOLD = 4

export const environmentColumn = (meta?: FeatureGatedColumnMeta) => {
  return columnHelper.display({
    id: 'environment',
    header: 'Environment',
    meta,
    cell: ({ row, table }) => {
      const environmentId = row.original.environment_id

      if (!environmentId) {
        return <Unavailable />
      }

      const visibleColumnCount = table.getVisibleLeafColumns().length
      const shouldLimitWidth = visibleColumnCount >= MAX_WIDTH_COLUMN_THRESHOLD

      return <EnvironmentColumn environmentId={environmentId} shouldLimitWidth={shouldLimitWidth} />
    },
  })
}

const EnvironmentColumn = ({
  environmentId,
  shouldLimitWidth,
}: {
  environmentId: string
  shouldLimitWidth: boolean
}) => {
  const environmentName = useGetEnvironmentName(environmentId)

  if (!environmentName) {
    return <Unavailable />
  }

  return (
    <CellAction
      search={(old) => ({ ...old, [key]: [environmentId] })}
      field={label}
      className={cn('truncate', shouldLimitWidth && 'max-w-48')}
    >
      <Typography className='block w-full truncate'>{environmentName}</Typography>
    </CellAction>
  )
}
